import FoodItem from './FoodItem'
import './index.scss'

const FoodsCategory = ({ name, foods ,cartList}) => {
  return (
    <div className="foodCategory">
      <dl className="cate-list">
        <dt className="cate-title">{name}</dt>

        {foods.map(item => {
          return <FoodItem key={item.id} {...item} cartList={cartList}/>
        })}
      </dl>
    </div>
  )
}

export default FoodsCategory
